import { render, staticRenderFns } from "./APIGatewayTable.vue?vue&type=template&id=91c54c9a"
import script from "./APIGatewayTable.vue?vue&type=script&lang=js"
export * from "./APIGatewayTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports